
type TextColor = 'black' | 'white';

export const GetContrastTextColor = ( color : string ) : TextColor => {
    
    const bgColor = rgbStringToArray( color );

    const r = bgColor[0];
    const g = bgColor[1];
    const b = bgColor[2];

    const luminance = ( 0.2126 * r + 0.7152 * g + 0.0722 * b ) / 255;  

    if ( luminance > 0.5 ) {
        return 'black'; 
    } 
    else {
        return 'white';
    }
}

export const hexToRgbArray = ( hex: string ): [number, number, number] => {
   
    hex = hex.replace(/^#/, '');

    if ( hex.length === 3 ) {
        hex = hex.split('').map(char => char + char).join('');
    }
    else if ( hex.length === 6 ) {
        hex = hex.split('').map(char => char + char).join('');
    }

    if (hex.length !== 6) {
        throw new Error("Formato hexadecimal inválido. Debe tener 3 o 6 caracteres.");
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return [r, g, b];
}

export const rgbStringToArray = ( rgbString: string ): [number, number, number] => {
    
  const matches = rgbString.match(/\d+/g);

  if (!matches || matches.length < 3) {
    throw new Error("Formato RGB inválido. Debe ser algo como 'rgb(255, 87, 51)'.");
  }

  // Convertir los valores a enteros
  const [r, g, b] = matches.map(Number);

  return [r, g, b];
}